(function(){
'use strict';
/* Dibuja el render y el archivo de corte y los adjunta al pedido. */
var C = {};
var $=function(id){return document.getElementById(id);};

function loadImg(src){
  return new Promise(function(res,rej){
    var i=new Image(); i.crossOrigin='anonymous';
    i.onload=function(){res(i);}; i.onerror=function(){rej(new Error('img'));};
    i.src=src;
  });
}
function famDe(a){ return C.fuenteDe(a.fuente).css; }
function txtDe(a){ return a.texto||''; }
function trEm(a){ return a.track/100; }

function anchoTrack(ctx,txt,trPx){
  var w=0;
  for(var i=0;i<txt.length;i++){ w+=ctx.measureText(txt[i]).width; if(i<txt.length-1)w+=trPx; }
  return w;
}
function pintaTrack(ctx,txt,cx,cy,trPx,stroke){
  var w=anchoTrack(ctx,txt,trPx), x=cx-w/2;
  for(var i=0;i<txt.length;i++){
    if(stroke)ctx.strokeText(txt[i],x,cy);
    ctx.fillText(txt[i],x,cy);
    x+=ctx.measureText(txt[i]).width+trPx;
  }
}
function fsPara(ctx,a,anchoPx){
  ctx.font='100px '+famDe(a);
  var w100=anchoTrack(ctx,txtDe(a),trEm(a)*100);
  if(!w100)return 10;
  return 100*anchoPx/w100;
}

var _inkCache={};
function inkBox(fam,txt,tr){
  var key=fam+'|'+txt+'|'+tr;
  if(_inkCache[key])return _inkCache[key];
  var FS=200, sc=document.createElement('canvas'), c0=sc.getContext('2d');
  c0.font=FS+'px '+fam;
  sc.width=Math.max(16,Math.ceil(anchoTrack(c0,txt,tr*FS))+FS*2);
  sc.height=FS*3;
  var ctx=sc.getContext('2d');
  ctx.font=FS+'px '+fam; ctx.textBaseline='middle'; ctx.textAlign='left'; ctx.fillStyle='#000';
  pintaTrack(ctx,txt,sc.width/2,sc.height/2,tr*FS,false);
  var d;
  try{ d=ctx.getImageData(0,0,sc.width,sc.height).data; }catch(e){ return null; }
  var minX=1e9,maxX=-1,minY=1e9,maxY=-1;
  for(var y=0;y<sc.height;y++){
    var row=y*sc.width;
    for(var x=0;x<sc.width;x++){
      if(d[(row+x)*4+3]>10){ if(x<minX)minX=x; if(x>maxX)maxX=x; if(y<minY)minY=y; if(y>maxY)maxY=y; }
    }
  }
  if(maxX<0)return null;
  var r={ w:(maxX-minX+1)/FS, h:(maxY-minY+1)/FS,
          dx:((minX+maxX)/2-sc.width/2)/FS, dy:((minY+maxY)/2-sc.height/2)/FS };
  _inkCache[key]=r; return r;
}
function fsInk(a,anchoPx){
  var b=inkBox(famDe(a),txtDe(a),trEm(a));
  if(!b||!b.w)return null;
  return {fs:anchoPx/b.w, box:b};
}

function pinturaDe(ctx,a,cx,w){
  if(a.color==='tornasol'){
    var g=ctx.createLinearGradient(cx-w/2,0,cx+w/2,0);
    g.addColorStop(0,'#D470A6');g.addColorStop(.18,'#E0B848');g.addColorStop(.40,'#3FBF9B');
    g.addColorStop(.62,'#4A8FD4');g.addColorStop(.84,'#9163C8');g.addColorStop(1,'#D470A6');
    return g;
  }
  return C.colorDe(a.color).hex;
}

function pie(ctx,cv,W,H,BAR,view){
  ctx.fillStyle='#1B1B1B'; ctx.fillRect(0,H,W,BAR);
  ctx.fillStyle='#FFFFFF'; ctx.textAlign='center';
  ctx.font='bold '+Math.round(BAR*0.30)+'px Arial,Helvetica,sans-serif';
  ctx.fillText('RENDER DE REFERENCIA — NO ES LA PRENDA REAL',W/2,H+BAR*0.36);
  ctx.fillStyle='#C9C9C9';
  ctx.font=Math.round(BAR*0.23)+'px Arial,Helvetica,sans-serif';
  ctx.fillText((view==='front'?'Frente':'Espalda')+'  ·  Ref '+C.REF_KEY+'  ·  Talla '+C.tallaSel()+'  ·  111 Cientonce',W/2,H+BAR*0.72);
  ctx.textAlign='left';
  return cv;
}

function renderCanvas(view){
  var lista=C.saved.filter(function(a){return a.view===view;});
  if(!lista.length)return Promise.resolve(null);
  return loadImg(C.vistaDe(view).img).then(function(img){
    var W=img.naturalWidth||1600, H=img.naturalHeight||1600, BAR=Math.round(W*0.075);
    var cv=document.createElement('canvas'); cv.width=W; cv.height=H+BAR;
    var ctx=cv.getContext('2d');
    ctx.fillStyle='#FFFFFF'; ctx.fillRect(0,0,W,H+BAR);
    ctx.drawImage(img,0,0,W,H);
    ctx.textBaseline='middle'; ctx.textAlign='left';

    var flags=[];
    lista.forEach(function(a){
      var objetivo=C.anchoDe(a)/C.vistaDe(a.view).frameCm*W;
      if(a.tipo==='bandera'){ flags.push({a:a,w:objetivo}); return; }
      var m=fsInk(a,objetivo), fs, ox=0, oy=0;
      if(m){ fs=m.fs; ox=m.box.dx*fs; oy=m.box.dy*fs; }
      else { fs=fsPara(ctx,a,objetivo); }
      ctx.font=fs+'px '+famDe(a);
      var tr=trEm(a)*fs, cx=a.x/100*W, cy=a.y/100*H, stroke=false;
      ctx.fillStyle=pinturaDe(ctx,a,cx,objetivo);
      if(a.color==='blanco'){ ctx.strokeStyle='rgba(27,27,27,.45)'; ctx.lineWidth=Math.max(1,fs*0.018); stroke=true; }
      pintaTrack(ctx,txtDe(a),cx-ox,cy-oy,tr,stroke);
    });

    return Promise.all(flags.map(function(o){
      return loadImg(C.banderaSrc(o.a.pais)).then(function(fi){
        var w=o.w, h=w*0.6, cx=o.a.x/100*W, cy=o.a.y/100*H;
        ctx.drawImage(fi, cx-w/2, cy-h/2, w, h);
        ctx.strokeStyle='rgba(0,0,0,.28)'; ctx.lineWidth=Math.max(1,W*0.0012);
        ctx.strokeRect(cx-w/2, cy-h/2, w, h);
      }).catch(function(){});
    })).then(function(){ return pie(ctx,cv,W,H,BAR,view); });
  });
}

function corteCanvas(a){
  var DPI=300, wpx=Math.round(a.ancho/2.54*DPI);
  var m=fsInk(a,wpx);
  var fs, ox=0, oy=0, hpx;
  if(m){ fs=m.fs; ox=m.box.dx*fs; oy=m.box.dy*fs; hpx=Math.ceil(m.box.h*fs); }
  else { fs=fsPara(document.createElement('canvas').getContext('2d'),a,wpx); hpx=Math.ceil(fs*1.1); }
  var pad=Math.round(DPI*0.04);
  var cv=document.createElement('canvas'); cv.width=wpx+pad*2; cv.height=hpx+pad*2;
  var ctx=cv.getContext('2d');
  ctx.textBaseline='middle'; ctx.textAlign='left';
  ctx.font=fs+'px '+famDe(a);
  var cx=cv.width/2;
  ctx.fillStyle=pinturaDe(ctx,a,cx,wpx);
  pintaTrack(ctx,txtDe(a),cx-ox,cv.height/2-oy,trEm(a)*fs,false);
  return cv;
}

function corteSVG(a){
  var anchoMM=a.ancho*10;
  var b=inkBox(famDe(a),txtDe(a),trEm(a));
  var altoMM = b ? +(anchoMM*b.h/b.w).toFixed(2) : anchoMM*0.3;
  var fam=C.fuenteDe(a.fuente).l.split(' —')[0];
  var fs = b ? +(anchoMM/b.w).toFixed(3) : anchoMM*0.7;
  var dx = b ? +(b.dx*fs).toFixed(3) : 0, dy = b ? +(b.dy*fs).toFixed(3) : 0;
  var col = a.color==='tornasol' ? 'url(#tor)' : C.colorDe(a.color).hex;
  var grad = a.color==='tornasol'
    ? '<defs><linearGradient id="tor" x1="0" x2="1"><stop offset="0" stop-color="#D470A6"/><stop offset=".18" stop-color="#E0B848"/><stop offset=".40" stop-color="#3FBF9B"/><stop offset=".62" stop-color="#4A8FD4"/><stop offset=".84" stop-color="#9163C8"/><stop offset="1" stop-color="#D470A6"/></linearGradient></defs>' : '';
  var esc=function(t){return t.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');};
  return '<?xml version="1.0" encoding="UTF-8"?>\n'+
    '<!-- 111 Cientonce · aplique a tamaño real: '+a.ancho+' cm de ancho.\n'+
    '     Tipografía: '+fam+' (Google Fonts, gratis). Si no la tienes instalada,\n'+
    '     usa el PNG a 300 dpi que viene en el mismo pedido.\n'+
    '     Antes de cortar: convertir texto a curvas / crear contornos. -->\n'+
    '<svg xmlns="http://www.w3.org/2000/svg" width="'+anchoMM+'mm" height="'+altoMM+'mm" '+
    'viewBox="0 0 '+anchoMM+' '+altoMM+'">'+grad+
    '<text x="'+(anchoMM/2-dx)+'" y="'+(altoMM/2-dy)+'" text-anchor="middle" '+
    'dominant-baseline="central" font-family="'+fam+'" font-size="'+fs+'" '+
    'letter-spacing="'+(trEm(a)*fs).toFixed(3)+'" fill="'+col+'">'+esc(txtDe(a))+'</text></svg>';
}

function aBlob(cv,tipo,q){ return new Promise(function(r){ cv.toBlob(r,tipo,q); }); }
function aFile(blob,nombre){ return new File([blob],nombre,{type:blob.type}); }
function slug(s){ return (s||'').toString().normalize('NFD').replace(/[̀-ͯ]/g,'')
  .replace(/[^a-zA-Z0-9]+/g,'-').replace(/^-|-$/g,'').toLowerCase().slice(0,40)||'111'; }

function armarArchivos(){
  var base=slug(C.REF_KEY)+'-'+slug(C.tallaSel());
  var jobs=[], out=[];
  ['front','back'].forEach(function(v){
    jobs.push(renderCanvas(v).then(function(cv){
      if(!cv)return;
      return aBlob(cv,'image/jpeg',0.92).then(function(b){
        out.push({k:'Render '+(v==='front'?'frente':'espalda'),
                  f:aFile(b,'render-'+(v==='front'?'frente':'espalda')+'-'+base+'.jpg')});
      });
    }));
  });
  C.saved.forEach(function(a,ix){
    if(a.tipo==='bandera')return;
    jobs.push(Promise.resolve().then(function(){
      var nom='corte-aplique'+(ix+1)+'-'+slug(a.texto)+'-'+C.dec(a.ancho).replace(',','_')+'cm';
      return aBlob(corteCanvas(a),'image/png').then(function(b){
        out.push({k:'Aplique '+(ix+1)+' · Archivo de corte (PNG 300dpi)', f:aFile(b,nom+'.png')});
        try{
          var sb=new Blob([corteSVG(a)],{type:'image/svg+xml'});
          out.push({k:'Aplique '+(ix+1)+' · Archivo de corte (SVG vectorial)', f:aFile(sb,nom+'.svg')});
        }catch(e){}
      });
    }));
  });
  return Promise.all(jobs).then(function(){ return out; });
}

function aviso(on,txt){
  var e=$('c111-wait');
  if(!e){
    e=document.createElement('div'); e.id='c111-wait'; e.className='c111-wait';
    e.innerHTML='<div class="bx"><div class="sp"></div><p id="c111-waittx"></p></div>';
    document.body.appendChild(e);
  }
  $('c111-waittx').textContent=txt||'Preparando tu render…';
  e.style.display=on?'flex':'none';
}

/* ---------------------------------------------------------------------------
   La app de opciones se queda con las propiedades "Aplique ..." y la API de
   Shopify no las devuelve. El único campo que sobrevive Y se lee por API es
   "Detalles". Le pegamos ahí los enlaces del render: así el pedido queda con
   la imagen a la vista y se puede automatizar.
   --------------------------------------------------------------------------- */
function sellarDetalles(){
  return fetch('/cart.js',{headers:{'Accept':'application/json'}})
    .then(function(r){return r.json();})
    .then(function(c){
      var it=null;
      for(var i=0;i<c.items.length;i++){
        var p=c.items[i].properties||{};
        if(p['Render frente']||p['Render espalda']){ it=c.items[i]; break; }
      }
      if(!it) return null;
      var props={}, k;
      for(k in it.properties) props[k]=it.properties[k];
      if(String(props['Detalles']||'').indexOf('RENDER')>=0) return null;
      var extra=[];
      if(props['Render frente'])  extra.push('RENDER FRENTE: '+props['Render frente']);
      if(props['Render espalda']) extra.push('RENDER ESPALDA: '+props['Render espalda']);
      for(k in props){
        if(k.indexOf('Archivo de corte')>0) extra.push('CORTE: '+props[k]);
      }
      if(!extra.length) return null;
      props['Detalles'] = (props['Detalles']||'') + '  ||  ' + extra.join('  ||  ');
      try{
        var io=JSON.parse(props['_io_properties']);
        io['Detalles']=props['Detalles'];
        props['_io_properties']=JSON.stringify(io);
      }catch(e){}
      return fetch('/cart/change.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({id:it.key, quantity:it.quantity, properties:props})
      });
    })
    .catch(function(){ return null; });
}

var enviando=false, sinImagenes=false;
function enviarConArchivos(f){
  enviando=true; aviso(true,'Preparando tu render…');
  armarArchivos().then(function(arch){
    aviso(true,'Guardando tu diseño…');
    var ifr=$('c111-ifr');
    if(!ifr){ ifr=document.createElement('iframe'); ifr.id='c111-ifr'; ifr.name='c111-ifr';
              ifr.style.cssText='position:absolute;width:0;height:0;border:0;left:-9999px'; document.body.appendChild(ifr); }
    var inputs=[];
    arch.forEach(function(o){
      var i=document.createElement('input');
      i.type='file'; i.className='c111-file'; i.name='properties['+o.k+']';
      var dt=new DataTransfer(); dt.items.add(o.f); i.files=dt.files;
      i.style.display='none'; f.appendChild(i); inputs.push(i);
    });
    var nota=document.createElement('input');
    nota.type='hidden'; nota.className='c111-file';
    nota.name='properties[Personalización · Archivos]';
    nota.value='Render de referencia (JPG) + archivo de corte por aplique en PNG 300 dpi y en SVG vectorial. El ancho del archivo YA es el ancho real del aplique: imprimir o cortar al 100%, sin escalar.';
    f.appendChild(nota); inputs.push(nota);
    var oldT=f.getAttribute('target'), oldE=f.getAttribute('enctype'), oldM=f.getAttribute('method');
    f.setAttribute('target','c111-ifr');
    f.setAttribute('enctype','multipart/form-data');
    f.setAttribute('method','post');
    var listo=false;
    ifr.onload=function(){
      if(listo)return; listo=true;
      inputs.forEach(function(i){i.remove();});
      if(oldT)f.setAttribute('target',oldT); else f.removeAttribute('target');
      if(oldE)f.setAttribute('enctype',oldE); else f.removeAttribute('enctype');
      if(oldM)f.setAttribute('method',oldM); else f.removeAttribute('method');
      aviso(true,'Guardando el render en tu pedido…');
      sellarDetalles().then(function(){ window.location.href='/cart'; });
    };
    HTMLFormElement.prototype.submit.call(f);
    setTimeout(function(){ if(!listo){ listo=true; window.location.href='/cart'; } },25000);
  }).catch(function(){
    aviso(false); enviando=false; sinImagenes=true;
    var b=f.querySelector('[type="submit"], .t4s-product-form__submit, button[name="add"]');
    if(b)b.click();
  });
}

function onATC(e){
  if(sinImagenes||enviando||!C.saved||!C.saved.length)return;
  var f=document.querySelector('form[action*="/cart/add"]'); if(!f)return;
  e.preventDefault(); e.stopImmediatePropagation();
  enviarConArchivos(f);
}
function bindATC(f){
  C = window.C111 || C;
  var b=f.querySelector('[type="submit"], .t4s-product-form__submit, button[name="add"]');
  if(!b||b.__c111)return; b.__c111=true;
  b.addEventListener('click',onATC,true);
}

(function(){
  if(document.getElementById('c111-wait-css'))return;
  var st=document.createElement('style'); st.id='c111-wait-css';
  st.textContent='.c111-wait{position:fixed;inset:0;z-index:2147483000;background:rgba(255,255,255,.94);display:none;align-items:center;justify-content:center}'+
  '.c111-wait .bx{text-align:center;max-width:300px;padding:0 20px}'+
  '.c111-wait .sp{width:34px;height:34px;margin:0 auto 18px;border:2px solid #E3E3E3;border-top-color:#1B1B1B;border-radius:50%;animation:c111spin .8s linear infinite}'+
  '@keyframes c111spin{to{transform:rotate(360deg)}}'+
  '.c111-wait p{font-size:14px;color:#1B1B1B;letter-spacing:.02em;margin:0;line-height:1.5}'+
  '.c111-flagprev{display:flex;align-items:center;gap:10px;margin:10px 0 0;font-size:12px;color:#6E6E6E}'+
  '.c111-flagprev img{width:56px;height:33.6px;border:1px solid #E3E3E3;display:block;flex:none}'+
  'img.c111-mark{display:block;object-fit:fill}';
  document.head.appendChild(st);
})();

function _ioSelect(){
  var s=document.querySelectorAll('select');
  for(var i=0;i<s.length;i++){
    var n=s[i].getAttribute('name')||'';
    if(n.indexOf('Quiero personalizar')>=0 || n.indexOf('Personalizar mi prenda')>=0) return s[i];
  }
  return null;
}
function _ioDetalles(){
  var e=document.querySelectorAll('input[name^="properties"], textarea[name^="properties"]');
  for(var i=0;i<e.length;i++){
    var n=e[i].getAttribute('name')||'';
    if(n.indexOf('Detalles')>=0 && n.indexOf('_io')<0) return e[i];
  }
  return null;
}
setInterval(function(){
  C = window.C111 || C;
  if(!C.saved || C.saved.length) return;
  var s=_ioSelect(); if(!s) return;
  var op=null;
  for(var i=0;i<s.options.length;i++){ if(/no\s*gracias/i.test(s.options[i].text)){op=s.options[i];break;} }
  if(op && s.value!==op.value){
    s.value=op.value;
    s.dispatchEvent(new Event('change',{bubbles:true}));
    s.dispatchEvent(new Event('input',{bubbles:true}));
  }
  var d=_ioDetalles();
  if(d && d.value){ d.value=''; d.dispatchEvent(new Event('change',{bubbles:true})); d.dispatchEvent(new Event('input',{bubbles:true})); }
},900);

window.C111captura = { bind: bindATC };
})();